<template lang="pug">
  #app
    cookie-law(theme="bixter")
      div.cookie-wrap(slot-scope="props")
        p
          span {{ interpolate(gettext('Our website uses cookies to distinguish you from other users of our website. This helps us to provide you with a good experience when you browse our website and also allows us to improve our site. By continuing to browse the site, you are agreeing to our use of cookies. Read more about the individual cookies we use and how to recognize them by clicking %(here)s'), [''], true) }}
          router-link(:to="`/${getLanguage}/privacy-policy`")  {{ gettext('here') }}.
        button.main-btn.col-white.bg-red(@click="props.accept") {{ gettext('Got it') }}
    div.ready-wrap(v-if="ready")
      .wrap-content(v-if="$auth.ready()")
        create-cv-reminder
        header-part
        .under-header
        .main-content
          router-view(v-if="ready" :key="reRenderPageCounter")
        footer-part
    div(v-else)
      .dynamic
        .level
          .level-item.has-text-centered
            loading
    back-to-top(text="")
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { ready, gettext, interpolate } from './services/TranslateHandler'
import Header from '@/parts/header'
import Footer from '@/parts/footer'
import Spinner from '@/components/spinner'
import BackToTop from 'vue-backtotop'
import createCvReminder from '@/components/create-cv-reminder'
import {LanguageMixin} from '@/mixins/LanguageMixin'
import CookieLaw from 'vue-cookie-law'
Vue.use(BackToTop)

export default {
  name: 'App',
  data () {
    return {
      ready: false,
      rerender: 1
    }
  },
  mixins: [LanguageMixin],
  components: {
    'header-part': Header,
    'footer-part': Footer,
    'loading': Spinner,
    BackToTop,
    CookieLaw,
    createCvReminder
  },
  methods: {
    ...mapActions([
      'receivePageMetaByUrl'
    ]),
    ...mapMutations([
      'setMetaInfo'
    ]),
    gettext: gettext,
    interpolate: interpolate,
    setLocalMedia (name, value, expires) {
      var data = {}
      data.value = value
      var d = new Date()
      d.setTime(d.getTime() + expires * 1000)
      data.expires = d
      window.localStorage.setItem(name, JSON.stringify(data))
      this.setMetaInfo(data)
    },
    getLocalMedia (name) {
      var data = JSON.parse(window.localStorage.getItem(name))
      if (!data) {
        return null
      }
      var now = new Date()
      var date = new Date(data.expires)
      if (date.getTime() > now.getTime()) {
        return JSON.parse(window.localStorage.getItem(name))
      } else {
        return null
      }
    },
    getMetaInfo () {
      let meta = this.getLocalMedia('meta' + this.$route.path)
      if (meta) {
        this.setMetaInfo(meta)
      } else {
        this.receivePageMetaByUrl({url: this.$route.path}).then(res => {
          this.setLocalMedia('meta' + this.$route.path, res.data.result, 3600)
        }).catch(err => {
          if (err.data.error.code === 1000) {
            this.setLocalMedia('meta' + this.$route.path, null, 3600)
          }
        })
      }
    }
  },
  async created () {
    ready(() => {
      this.ready = true
    })
    this.$bus.$on('user', async (user) => {
      await this.$store.dispatch('setUser', user)
      this.languageUpdate()
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.getMetaInfo()
    })
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'reRenderPageCounter'
    ])
  },
  watch: {
    '$route': function () {
      this.getMetaInfo()
    },
    getLanguage: function () {
      this.languageUpdate()
    }
  }
}
</script>

<style lang="scss" src="./main.scss"></style>



// WEBPACK FOOTER //
// src/App.vue